<template>
  <div>
    <v-head></v-head>
    <div style="width: 100%; background-color: #fff">
      <div class="informationBox_header">
        <div class="logo" @click="$router.push('/index')">
          <img src="/static/image/newLogo.png" />
          <div class="line"></div>
          <div class="logo-des">
            <p>消费帮促</p>
            <p>采购平台</p>
          </div>
        </div>
        <div class="headerContent">
          <img class="headerImg" src="/static/image/infoTop.png" />
          <div>—— 资讯中心 ——</div>
        </div>
      </div>
    </div>
    <div class="informationBox">
      <div class="navListBox">
        <div
          v-for="(item, index) in navList"
          :key="index"
          :class="['navList_item', activeInd == index ? 'active' : '']"
          @click="changeNav(index)"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- 资讯中心 -->
      <div class="infoCenterBox" v-if="activeInd == 0">
        <div class="boxList" v-for="(item, index) in dataList" :key="index">
          <div class="boxList_titleBox">
            <div class="boxList_title">
              <img
                src="/static/image/infoIcon.png"
                alt=""
                class="iconImg"
              /><span>{{ item.name }}</span>
            </div>
            <span class="boxList_link" @click="activeInd = index + 1"
              >更多<i class="el-icon-arrow-right" style="margin-left: 5px"></i
            ></span>
          </div>
          <div
            class="boxList_item"
            v-for="(it, ind) in item.newsInfoVoList"
            :key="ind"
            @click="gotoDetails(it.id)"
          >
            <div class="boxList_itemText">
              {{ it.title }}
            </div>
            <div class="boxList_itemTime">{{ getDate(it.createTime) }}</div>
          </div>
        </div>
      </div>
      <!-- 其他资讯 -->
      <div class="otherBox" v-if="activeInd != 0">
        <div class="boxList_titleBox">
          <div class="boxList_title">
            <img src="/static/image/infoIcon.png" alt="" class="iconImg" /><span
              >{{ chooseData.name }}</span
            >
          </div>
          <span class="boxList_link"
            >更多<i class="el-icon-arrow-right" style="margin-left: 5px"></i
          ></span>
        </div>
        <div
          class="boxList_item"
          v-for="(item, index) in chooseData.newsInfoVoList"
          :key="index"
          @click="gotoDetails(item.id)"
        >
          <div class="boxList_itemText">
            {{ item.title }}
          </div>
          <div class="boxList_itemTime">{{ getDate(item.createTime) }}</div>
        </div>
        <!-- 分页 -->
        <!-- <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="current"
            layout=" prev, pager, next,total, jumper"
            :total="total"
            :page-size="limit"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import vHead from "../common/header2.vue";
import { doPost } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
export default {
  components: { vHead },
  data() {
    return {
      navList: "",
      dataList: "",
      chooseData: "",
      activeInd: 0,
      current: 1, //当前页数
      total: 0, //总条数
      limit: 8, //每页显示几条
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    /**
     * 资讯详情
     */
    gotoDetails(id) {
      this.$router.push({ path: "/infoDetails", query: { id: id } });
    },
    /**
     * 点击左侧导航栏
     */
    changeNav(index) {
      this.activeInd = index;
      if (index != 0) {
        this.chooseData = this.navList[index];
      }
    },
    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      this.getList(val);
    },
    getData() {
      var that = this;
      doPost(
        httpConfig.Footer.getListUrl,
        { location: 2 },
        function (res) {
          that.dataList = res;
          var data = JSON.parse(JSON.stringify(res));
          data.unshift({ name: "资讯中心" });
          that.navList = data;
        },
        function (res) {}
      );
    },
    /**
     * 时间格式化（补0）
     */
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    /**
     * 时间戳转换
     */
    getDate(time) {
      if (!time) return "";
      if (time == typeof string) {
        var reg = getRegExp("-", "g"); // 获取正则表达式，全局替换
        time = time.replace(reg, "/");
      }
      var date = new Date(time);
      var M = date.getMonth() + 1;
      var y = date.getFullYear();
      var d = date.getDate();
      var h = date.getHours();
      var mm = date.getMinutes();
      var s = date.getSeconds();
      if (M < 10) M = "0" + M;
      if (d < 10) d = "0" + d;
      return (
        y +
        "." +
        M +
        "." +
        d +
        " " +
        this.add0(h) +
        ":" +
        this.add0(mm) +
        ":" +
        this.add0(s)
      );
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/infoCenter";
</style>



// WEBPACK FOOTER //
// src/components/page/infoCenter.vue